import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";
const urlApi = process.env.REACT_APP_API_KEY;

export const fetchFolioDataService = async (folioId) => {
    try {
        // Llamada a la API
        const response = await api.get(`${urlApi}/payments/getFolioData/${folioId}`);
        return response.data;

    } catch (err) {
        console.error('Error al cargar datos del folio:', err);
        await Swal.fire(
            'Error',
            'No se pudo cargar la información del folio',
            "error"
        );
    }
};

export const confirmDistribution = async (payload) => {
    try {
        // Llamada a la API
        const response = await api.post(`${urlApi}/payments/confirmDistribution`, payload);
        return response.data;

    } catch (err) {
        throw err;
    }
};